import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEyeVisible = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EyeVisible</title>
    <path
      d="M16.998 21.775a4.778 4.778 0 1 1 0-9.555 4.778 4.778 0 0 1 0 9.555Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M3.576 15.555c3.912-5.924 8.39-8.701 13.421-8.701 5.032 0 9.51 2.777 13.422 8.7l.834-.55-.834.55a2.603 2.603 0 0 1 0 2.888c-3.907 5.923-8.385 8.7-13.422 8.7-5.036 0-9.514-2.777-13.422-8.7l-.835.551.835-.55a2.603 2.603 0 0 1 .001-2.889Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoEyeVisible;
